import { getDoc, doc } from "firebase/firestore";
import { db } from "../utils/firebase.jsx";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

export default function ProposalListing({ data }) {
  // console.log('ProposalListing');
  const proposals = data;
  if (proposals.length == 0) {
    return <h4>No Active Proposals</h4>;
  }

  const userID = localStorage.getItem("id");
  const [userCom, setUserCom] = useState();

  // useEffect(() => {
  // async function ableToVote() {
  //   if (!userID) return;
  //   const docRef = doc(db, "Users", userID);
  //   const docSnap = await getDoc(docRef);
  //   setUserCom(docSnap.data().community);
  //   console.log(userCom);
  //   console.log(proposals);
  // }
  // ableToVote();
  // }, []);

  return (
    <>
      {proposals.map((proposal, i) => {
        return (
          <div
            className="row"
            style={{
              border: "2px solid lightgrey",
              margin: "1em 0",
              padding: "8px 2px",
            }}
            key={uuidv4()}
          >
            <div className="col-8">
              <h4>{proposal.title}</h4>
              {/*  */}
              {/* <p>{proposal.description}</p> */}
              <small>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-clock"
                  viewBox="0 0 16 16"
                  color="green"
                >
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                </svg>{" "}
                Voting Deadline: {proposal.endDate.toDate().toDateString()}
              </small>
            </div>
            <div
              className="col-4 text-center"
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <Link
                  to={`/${proposal.slug}/${proposal.id}`}
                  type="button"
                  className="btn btn-outline-dark btn-info"
                >
                  View this Proposal
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
